// In-repo replacement for the `uuid` package. We previously used `v4` and
// `validate` only — both are trivial wrappers around the platform crypto
// primitives.
//
// `crypto.randomUUID` is gated on secure contexts, so it's missing when local
// dev is served over plain HTTP from a hostname other than `localhost` /
// `127.0.0.1` (e.g. `localhost-production`, a LAN IP), and on very old
// browsers. Fall back to `crypto.getRandomValues`, which is available in
// insecure contexts and in Node 19+.

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function v4(): string {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function validate(value: unknown): boolean {
  return typeof value === 'string' && UUID_REGEX.test(value);
}
